<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>工单管理</el-breadcrumb-item>
      <el-breadcrumb-item>工单管理列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row style="margin-top: 20px;">
      <h2 class="el_h2">工单管理</h2>
    </el-row>
    <!-- 查询表单 -->
    <el-form
    ref="work_form"
    :model="work_form"
    label-width="120px"
    class="work_form"
    >
      <el-form-item label="关键字" prop="key">
        <el-input v-model="work_form.key" placeholder="工单标题模糊查询"></el-input>
      </el-form-item>
      <el-form-item label="所属产品" prop="productCodeId">
        <el-select
        style="width: 100%;"
        :popper-append-to-body="false"
        v-model="work_form.productCodeId"
        placeholder="请选择产品类型"
        clearable
        >
          <el-option
          v-for="item in product_list"
          :key="item.value"
          :label="item.name"
          :value="item.value"
          :disabled="item.disabled"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工单状态" prop="status">
        <el-select
        style="width: 100%;"
        :popper-append-to-body="false"
        v-model="work_form.status"
        placeholder="请选择工单状态"
        clearable
        @change="check_switch"
        >
          <el-option
          v-for="item in work_status_list"
          :key="item.value"
          :label="item.name"
          :value="item.value"
          :disabled="item.disabled"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="受理人" prop="handleUserId">
        <el-select
        style="width: 100%;"
        :popper-append-to-body="false"
        v-model="work_form.handleUserId"
        placeholder="请选择受理人"
        clearable
        >
          <el-option
          v-for="item in receiver"
          :key="item.value"
          :label="item.name"
          :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="显示关闭的工单" prop="showClose">
        <el-switch
        v-model="work_form.showClose"
        >
        </el-switch>
      </el-form-item>
      <el-form-item>
        <el-button @click="search_work()" type="primary">查询</el-button>
        <el-button @click="reset_wrok()">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 工单管理列表 -->
    <el-table
    :data="listData"
    max-height="400"
    border
    >
      <el-table-column type="index" align="center" label="NO"></el-table-column>
      <el-table-column
      show-overflow-tooltip
      prop="proTitle"
      label="工单标题"
      ></el-table-column>
      <el-table-column prop="productTypeText" label="问题类别"></el-table-column>
      <el-table-column prop="statusText" label="工单状态"></el-table-column>
      <el-table-column prop="userNickName" label="创建人"></el-table-column>
      <el-table-column prop="handleNickName" label="受理人"></el-table-column>
      <el-table-column
      show-overflow-tooltip
      prop="createTime"
      label="发布时间"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-tag
          class="operate"
          effect="dark"
          @click="row_detail(scope.row)"
          v-if="btn_permission.includes('scc:demandMange:detail')||btn_permission.includes('superAdmin')"
          >
            查看详情
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <!-- 工单管理列表分页 -->
    <el-pagination
    style="margin: 10px auto;"
    background
    @size-change="pageparm_size_change"
    @current-change="pageparm_current_change"
    :current-page="pageparm.currentPage"
    :page-sizes="[10, 15, 20, 25]"
    :page-size="pageparm.pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="pageparm.total"
    ></el-pagination>
    <!-- 工单管理详情 -->
    <el-dialog
    :append-to-body="true"
    :visible.sync="detail_show"
    width="80%"
    >
      <el-steps :active="step_active" finish-status="success" simple style="margin-bottom: 20px;">
        <el-step
        v-for="item in work_status_list"
        :key="item.value"
        :title="item.name"></el-step>
      </el-steps>
      <el-row class="el_tab_row" style="font-weight: 700;">
        <span>工单标题：{{detail_data.proTitle}}</span>
        <span>工单编号：{{detail_data.id}}</span>
        <span>产品类型：{{detail_data.productCodeText}}</span>
        <span>问题类型：{{detail_data.problemCodeText}}</span>
      </el-row>
      <el-row class="el_tab_row">
        <span>提交时间：{{detail_data.createTime}}</span>
        <span>状态：{{detail_data.statusText}}</span>
        <span>受理人：{{detail_data.handleNickName}}</span>
        <span>
          <el-tag
          class="operate"
          effect="dark"
          v-if="step_active==1&&btn_permission.includes('scc:demandMange:assign')||step_active==1&&btn_permission.includes('superAdmin')"
          @click="assign_work"
          >指派工单</el-tag>
          <el-tag
          class="operate"
          effect="dark"
          v-if="step_active==1&&btn_permission.includes('scc:demandMange:handle')||step_active==1&&btn_permission.includes('superAdmin')"
          @click="accept_work"
          >受理工单</el-tag>
        </span>
      </el-row>
      <el-row class="linkup_message">
        <h2 class="el_h2" style="display: flex;align-items: center;">沟通记录
          <i @click="return_message()"
          class="el-icon-s-comment"
          v-if="step_active!=1&&btn_permission.includes('scc:demandMange:confirm')||step_active!=1&&btn_permission.includes('superAdmin')"
          ></i>
        </h2>
        <el-timeline style="padding: 10px;">
          <el-timeline-item :key="index" v-for="(item,index) in detail_data.processList" :timestamp="item.userMsg+' '+item.createTime" placement="top">
            <el-card>
              <div v-html="item.processText"></div>
              <div :style="{'margin-top': (item.accessories==null?0:20+'px')}">
                <el-image
                v-for="(item1,index) in item.accessories"
                :key="index"
                :initial-index="index"
                @click="show_big_message(item1.url,item1.conUrl,item.accessories)"
                :preview-src-list="src_list"
                style="margin-right: 10px;cursor: pointer;width: 100px;height: 100px;"
                :src="item1.url==null?'http://10.18.52.99:8080/group1/image/20211210/contractions/con8169140860153709639.jpg':item1.url+'?auth_token='+upload_token"
                ></el-image>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </el-row>
    </el-dialog>
    <!-- 查看大图 -->
    <el-dialog
    :append-to-body='true'
    width="80%"
    :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>
    <!-- 指派工单弹框 -->
    <el-dialog
    :append-to-body="true"
    :visible.sync="assign_show"
    >
      <el-table
      :data="userData"
      max-height="300"
      @row-dblclick="assign_dblclick"
      >
        <el-table-column prop="value" label="NO"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 工程师回复工单弹框 -->
    <el-dialog
    title="工程师回复工单"
    :append-to-body="true"
    :visible.sync="user_return"
    >
      <el-form
      ref="return_form"
      :model="return_form"
      label-width="100px"
      class="return_form"
      :rules="return_rules"
      >
        <el-form-item label="沟通信息" prop="processText">
          <quill-editor
          class="editor"
          ref="returnEditor"
          v-model="return_form.processText"
          :options="editorOption"
          >
          </quill-editor>
        </el-form-item>
        <el-form-item label="图片/文件上传">
          <el-upload
          :action="publicAjax.extra_path+file_path"
          list-type="picture-card"
          :auto-upload="true"
          :headers="{'scctoken':upload_token}"
          name="file"
          :file-list="file_list"
          :before-upload="change_file"
          :on-preview="show_big"
          :on-remove="remove_file"
          :on-success="success_file"
          :limit="4"
          ref="return_upload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button @click="submit_return()" type="primary">提交</el-button>
          <el-button @click="reset_return()">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../Pagination'
  export default {
    data() {
      return{
        upload_token:localStorage.getItem(localStorage.getItem('userName')+'token'),
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        //产品类型列表
        product_list:[],
        //受理人列表
        receiver:[],
        //工单状态
        work_status_list:[],
        //工单管理列表
        listData:[],
        //工单管理列表分页
        pageparm:{
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        //查询表单
        work_form:{
          key:'',
          productCodeId:'',
          status:'',
          handleUserId:'',
          showClose:false
        },
        //工单管理详情相关
        detail_show:false,
        detail_data:{},
        step_active:1,
        assign_show:false,
        userData:[],
        //图片相关
        dialogVisible:false,
        dialogImageUrl:'',
        file_list:[],
        file_list_new:[],
        file_path:'',
        src_list:['http://10.18.52.99:8080/group1/image/20211210/contractions/con8169140860153709639.jpg'],
        //富文本相关
        editorOption:{
          modules:{
            toolbar:[//工具菜单栏配置
              ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
              ["blockquote", "code-block"], // 引用  代码块
              [{ header: 1 }, { header: 2 }], // 1、2 级标题
              [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
              [{ script: "sub" }, { script: "super" }], // 上标/下标
              [{ indent: "-1" }, { indent: "+1" }], // 缩进
              // [{'direction': 'rtl'}],                         // 文本方向
              [{ size: ["small", false, "large", "huge"] }], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              [{ font: [] }], // 字体种类
              [{ align: [] }], // 对齐方式
              ["clean"], // 清除文本格式
              ["link", "image", "video"]//链接、图片、视频
            ]
          },
          placeholder:'请输入内容',
          readonly:false,
          theme:'snow',
          syntax:true
        },
        //工程师回复工单相关
        user_return:false,
        return_form:{
          processText:'',
          accessories:[]
        },
        return_rules:{
          processText:[
            {required:true,message:'请输入沟通信息',trigger:'blur'}
          ]
        }
      }
    },
    //注册组件
    components:{
      Pagination
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      if(JSON.stringify(that.$route.params)!='{}'){
        that.work_form.handleUserId=that.$route.params.handleUserId
        that.work_form.status=Number(that.$route.params.work_status)
        that.check_switch(that.work_form.status)
      }
      //根据typeCode查询产品类型列表
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/byCode/productType?pID=-1'
      }).then(data=>{
        if(data.data.success==true){
          that.product_list=data.data.data
        }else{
          that.$message.error(data.data.message)
        }
      })
      //工单状态下拉列表
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/sccOwn/orderWork/select/orderStatus'
      }).then(data=>{
        if(data.data.success==true){
          that.work_status_list=data.data.data
        }else{
          that.$message.error(data.data.message)
        }
      })
      //获取用户列表
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/user/select/commandMange'
      }).then(data=>{
        if(data.data.success=true){
          that.receiver=data.data.data
          that.userData=data.data.data
        }else{
          that.$message.error(data.data.message)
        }
      })
      //工单管理列表
      that.work_list()
    },
    mounted() {

    },
    watch:{
      '$route':function(){
        if(JSON.stringify(this.$route.params)!='{}'){
          this.work_form.handleUserId=this.$route.params.handleUserId
          this.work_form.status=Number(this.$route.params.work_status)
          this.check_switch(this.work_form.status)
          //工单管理列表
          this.work_list()
        }
      }
    },
    methods:{
      //工单管理分页
      pageparm_size_change(val){
        this.pageparm.pageSize=val
        //工单管理列表
        this.work_list()
      },
      pageparm_current_change(val){
        this.pageparm.currentPage=val
        //工单管理列表
        this.work_list()
      },
      //工单管理列表
      work_list(){
        let that=this
        that.$axios.get(that.publicAjax.extra_path+'/sccOwn/orderWork/mangeList',{
          params:{
            page:that.pageparm.currentPage,
            limit:that.pageparm.pageSize,
            key:that.work_form.key,
            productCodeId:that.work_form.productCodeId,
            status:that.work_form.status,
            handleUserId:that.work_form.handleUserId,
            showClose:that.work_form.showClose
          }
        }).then(data=>{
          if(data.data.success==true){
            //获取当前用户按钮权限
            that.$axios({
              method:'get',
              url:that.publicAjax.extra_path+'/admin/user/permission'
            }).then(data=>{
              if(data.data.success==true){
                that.btn_permission=data.data.data
              }else{
                that.$message.error(data.data.message)
              }
            })
            that.listData=data.data.data.list
            that.pageparm.total=data.data.data.total
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      check_switch(val){
        if(val==111){
          this.work_form.showClose=true
        }else{
          this.work_form.showClose=false
        }
      },
      //查询工单管理列表
      search_work(){
        this.pageparm.currentPage=1
        this.pageparm.pageSize=10
        //工单管理列表
        this.work_list()
      },
      //重置查询
      reset_wrok(){
        this.$refs['work_form'].resetFields()
        this.pageparm.currentPage=1
        this.pageparm.pageSize=10
        //工单管理列表
        this.work_list()
      },
      //工单管理详情相关
      row_detail(row){
        let that=this
        if(row.statusText=='待分配'){
          that.step_active=1
        }else if(row.statusText=='处理中'){
          that.step_active=2
        }else if(row.statusText=='待确认'){
          that.step_active=3
        }else if(row.statusText=='已关单'){
          that.step_active=4
        }
        that.detail_show=true
        //工单管理员查询工单详情
        that.get_workdetail(row.id)
      },
      //工单管理员查询工单详情
      get_workdetail(id){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/sccOwn/orderWork/mangeDetail/'+id
        }).then(data=>{
          if(data.data.success=true){
            that.detail_data=data.data.data
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //指派工单前置
      assign_work(){
        this.assign_show=true
      },
      //指派工单
      assign_dblclick(row, column, event){
        let that=this
        that.assign_show=true
        that.$axios({
          method:'put',
          url:that.publicAjax.extra_path+'/sccOwn/orderWork/assign/'+that.detail_data.id+'/'+row.value
        }).then(data=>{
          if(data.data.success==true){
            that.$message.success(data.data.message)
            that.assign_show=false
            //工单管理列表
            that.work_list()
            that.step_active=2
            //工单管理员查询工单详情
            that.get_workdetail(that.detail_data.id)
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //受理工单
      accept_work(){
        let that=this
        that.$axios({
          method:'put',
          url:that.publicAjax.extra_path+'/sccOwn/orderWork/handle/'+that.detail_data.id
        }).then(data=>{
          if(data.data.success==true){
            that.$message.success(data.data.message)
            //工单管理列表
            that.work_list()
            that.step_active=2
            //工单管理员查询工单详情
            that.get_workdetail(that.detail_data.id)
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //图片上传相关
      change_file(file){
        return new Promise((resolve, reject)=>{
          this.$nextTick(()=>{
            if(file.type.indexOf('image')!=-1){
              this.file_path='/sccOwn/upload/image/orderWork'
            }else{
              this.file_path='/sccOwn/upload/file/orderWork'
            }
            resolve()
          })
        })
      },
      //查看大图
      show_big(file){
        this.dialogImageUrl=file.url
        this.dialogVisible=true
      },
      //沟通记录图片点击事件
      show_big_message(file,other_file,item1){
        this.src_list=[]
        if(other_file==null){
          window.location.href=file
        }else{
          item1.forEach((ele,index)=>{
            this.src_list.push(ele.url+'?auth_token='+this.upload_token)
          })
        }
      },
      //图片上传成功回调
      success_file(data,file,fileList){
        if(data.success==true){
          this.$message.success(data.message)
          this.file_list.push({
            conUrl:this.publicAjax.image_path+data.data[0].conUrl,
            url:this.publicAjax.image_path+data.data[0].url+'?auth_token='+this.upload_token
          })
          this.file_list_new.push({
            conUrl:this.publicAjax.image_path+data.data[0].conUrl,
            url:this.publicAjax.image_path+data.data[0].url
          })
          let form_img=[]
          this.file_list_new.forEach(item=>{
            form_img.push({
              conUrl:item.conUrl,
              url:item.url
            })
          })
          this.return_form.accessories=form_img
        }
      },
      //移除图片
      remove_file(file,fileList){
        this.file_list=fileList
        this.file_list_new=fileList
        let list=[]
        this.file_list_new.forEach(item=>{
          list.push({
            conUrl:item.conUrl,
            url:item.url
          })
        })
        this.return_form.accessories=list
      },
      //回复工单前置
      return_message(){
        let that=this
        that.user_return=true
        if(that.$refs['return_form']!=undefined){
          that.$refs['return_form'].resetFields()
          that.$refs['return_upload'].clearFiles()
        }
        that.file_list=[]
        that.file_list_new=[]
      },
      //提交回复工单
      submit_return(){
        let that=this
        that.$refs['return_form'].validate((valid)=>{
          if(valid){
            that.$axios({
              method:'post',
              url:that.publicAjax.extra_path+'/sccOwn/orderWork/confirm/'+that.detail_data.id,
              data:that.return_form,
              headers:{
                "content-type":"application/json;charset=UTF-8"
              }
            }).then(data=>{
              if(data.data.success==true){
                that.$message.success(data.data.message)
                //工单管理列表
                that.work_list()
                that.user_return=false
                that.step_active=3
                //用户查询工单详情
                that.get_workdetail(that.detail_data.id)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }else{
            return false
          }
        })
      },
      //重置回复工单
      reset_return(){
        this.$refs['return_form'].resetFields()
        this.$refs['return_upload'].clearFiles()
        this.return_form.accessories=[]
      },
      //富文本转纯文本
      HTMLDecode(text) {
          var temp = document.createElement("div");
          temp.innerHTML = text;
          var output = temp.innerText || temp.textContent;
          temp = null;
          return output;
      }
    }
  }
</script>

<style scoped="scoped">
  .el_h2{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 0 0 20px;
    font-size: 16px;
    background: #F5F7FA;
  }
  .operate{
    margin-bottom: 2px;
    cursor: pointer;
  }
  .work_form .el-form-item{
    width: 49%;
    display: inline-block;
  }
  .work_form .el-form-item:last-child{
    width: 100%;
  }
  @media screen and (max-width:720px){
    .work_form .el-form-item{
      width: 100%;
    }
  }
  .el_tab_row{
    display: flex;
    align-items: center;
    padding: 20px 0 10px;
    background: #F5F7FA;
  }
  .el_tab_row>span{
    width: 24%;
    padding: 0 0.5%;
  }
  .linkup_message{
    border: 2px solid #F5F7FA;
    margin-top: 20px;
    height: 350px;
    overflow-y: auto;
  }
  .el-icon-s-comment{
    color: #409eff;
    font-size: 30px;
    cursor: pointer;
    margin-left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/work_order/manage_list.vue